import { render, staticRenderFns } from "./holderDelete.vue?vue&type=template&id=1a783195&"
import script from "./holderDelete.vue?vue&type=script&lang=js&"
export * from "./holderDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports